<template>
  <cockpit-dialog
    title="SiS"
    width="calc(100vw - 120px)"
    height="calc(100vh - 100px)"
    top="70px"
    left="60px"
    cardType="horizontal"
    @close="closeDialog"
  >
    <div class="h-full w-full" v-loading="loading">
      <iframe v-show="!!sisAddress" class="h-full w-full" :src="sisAddress" />
    </div>
  </cockpit-dialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import { DeviceSisAddressRelationApi } from '@wiz-api/huizhou2-business'

const deviceSisAddressRelationApi = new DeviceSisAddressRelationApi()

export default {
  components: { CockpitDialog },
  props: {
    code: {
      type: String,
      require: true,
    },
    systemCode: {
      type: String,
      require: true,
    },
    unitCode: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      loading: false,
      sisAddress: '',
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    async getSisList() {
      this.loading = true
      const params = {
        systemCode: this.systemCode,
        unitCode: this.unitCode,
        skipCount: 0,
        maxResultCount: 15,
      }
      const [err, res] = await deviceSisAddressRelationApi.getDeviceRelatedSisAddresses(params)
      if (!err && res) {
        // 展示绑定的第一个sis
        if (res.items.length > 0) {
          this.sisAddress = res.items[0].address
        }
      }
      setTimeout(() => {
        this.loading = false
      }, 10 * 1000)
    },
  },
  created() {
    this.getSisList()
  },
}
</script>

<style lang="scss" scoped></style>>
